import { gql } from "@apollo/client";

export default gql`
  mutation saveMeetingVideoRecordingMutation($meetingId: Int!) {
    saveMeetingVideoRecording(meetingId: $meetingId) {
      meeting {
        id
        transcript {
          id
          videoRecording
          canSaveVideoRecording
          videoRecordingAvailableUntil
        }
      }
    }
  }
`;
